import React from 'react'
import {Icon} from '@chakra-ui/react'
const CartIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 3.09723H5.71002L4.93571 0H0V2.06482H3.32355L7.45319 18.5834H21.6806V16.5185H9.06535L8.54914 14.4537H21.4763L24 3.09723ZM8.03343 12.3889L6.22671 5.16204H21.4265L19.8205 12.3889H8.03343Z"
                fill="currentColor"
            />
            <path
                d="M19.6158 23.7454C18.4752 23.7454 17.5509 22.8212 17.5509 21.6806C17.5509 20.54 18.4752 19.6158 19.6158 19.6158C20.7563 19.6158 21.6806 20.54 21.6806 21.6806C21.6806 22.8212 20.7563 23.7454 19.6158 23.7454Z"
                fill="currentColor"
            />
            <path
                d="M9.29168 23.7454C8.15109 23.7454 7.22686 22.8212 7.22686 21.6806C7.22686 20.54 8.15109 19.6158 9.29168 19.6158C10.4323 19.6158 11.3565 20.54 11.3565 21.6806C11.3565 22.8212 10.4323 23.7454 9.29168 23.7454Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CartIcon
